export default __webpack_public_path__ + "static/media/app.556ae12c.png";